import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <footer id="footer">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-5 col-sm-6 padLR15 about-GO">
              <h3>About Green Orange</h3>
              <div className="title-btm-style">
                <span></span>
              </div>
              <p>
                GreenOrange Private Limited is a global software product, information technology,
                consulting and outsourcing company.
              </p>
              <p>
                GreenOrange helps customers do business better by leveraging our industry-wide
                experience, deep technology expertise, comprehensive portfolio of services and
                vertically aligned business model.
              </p>
              <p>
                In today's world, organizations will have to rapidly reengineer themselves and be
                more responsive to changing customer needs. GreenOrange is well positioned to be a
                partner and co-innovator to businesses in their transformation journey, identify
                new growth opportunities and facilitate their foray into new sectors and markets.
              </p>
              <p>
                <Link to="/about" title="Show More" className="btn btn-lg btn-default foot-btn-style">
                  Show More
                </Link>
              </p>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-6 padLR15 prod-services">
              <h3>Products</h3>
              <div className="title-btm-style">
                <span></span>
              </div>
              <ul className="pad0">
                <li>
                  <Link to="/transport-management-system" title="Transport Management System">
                    Transport Management System
                  </Link>
                </li>
                <li>
                  <Link to="/payroll" title="Payroll">
                    Payroll
                  </Link>
                </li>
                <li>
                  <Link to="/gps-tracking-software" title="GPS Tracking as Software">
                    GPS Tracking as Software
                  </Link>
                </li>
              </ul>
              <h3 className="padT12">Services</h3>
              <div className="title-btm-style">
                <span></span>
              </div>
              <ul className="pad0">
                <li>
                  <Link to="/applications" title="Applications">
                    Applications
                  </Link>
                </li>
                <li>
                  <Link to="/enterprise-resource-planning" title="Enterprise Resource Planning">
                    ERP
                  </Link>
                </li>
                <li>
                  <Link to="/consulting" title="Consulting">
                    Consulting
                  </Link>
                </li>
                <li>
                  <Link to="/mobility" title="Mobility">
                    Mobility
                  </Link>
                </li>
                <li>
                  <Link to="/business-process" title="Business Process">
                    Business Process
                  </Link>
                </li>
                <li>
                  <Link to="/gps-tracking-service" title="GPS Tracking as Service">
                    GPS Tracking as Service
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-12 contact-info">
              <h3>Contact Information</h3>
              <div className="title-btm-style cont-info">
                <span></span>
              </div>
              <div className="info-div">
                <i className="fa fa-map-marker"></i>
                <h4>India</h4>
                <p>
                  G-36 & 37, Tidel Park, ELCOT SEZ<br />
                  Vilankurichi Road, Civil Aerodrome Post,<br />
                  Coimbatore-641014, Tamilnadu,<br />
                  India<br /> +91 422 297 4960
                </p>
              </div>
              <div className="info-div padT8">
                <i className="fa fa-map-marker"></i>
                <h4>Malaysia</h4>
                <p>
                  No 54, Jalan TS 6/9<br />
                  Taman Perindustrian Subang Jaya<br />
                  47620 Subang Jaya<br /> Malaysia<br />
                  +60 16 303 5034
                </p>
              </div>
              <div className="clearfix"></div>
              <div className="info-div noborder padT8">
                <i className="fa fa-location-arrow padB0"></i>
                <p className="color2">
                  sales@greenorange.in<br />
                  info@greenorange.in
                </p>
              </div>
            </div>
          </div>
          <div className="row footer-bottom">
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
              Copyright &copy; 2015 Green Orange
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
              <Link to="/sitemap" title="Site Map">
                Site Map
              </Link>
              <span>|</span>
              <Link to="/careers" title="Careers">
                Careers
              </Link>
              <span>|</span>
              <Link to="/privacy-policy" title="Privacy Policy" className="marR0">
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>
        <div className="go-top">
          <a href="#gotop" title="Back to Top" className="gotop" onClick={scrollToTop}>
            <i className="fa fa-arrow-up"></i>
          </a>
        </div>
      </footer>
    </>
  );
};

export default Footer;

